<div class="nav-container" [class.nav-container-open]="expanded" [class.nav-container-closed]="!expanded">
  <div class="header relative">
    <span class="logo">
      <img src="../../../assets/icons/sandi-lite-dark.svg" />
    </span>
    <span (click)="expanded = !expanded" [class.close-arrow]="expanded" [class.open-arrow]="!expanded" class="arrow">
      <i *ngIf="expanded" class="material-icons">keyboard_double_arrow_left</i>
      <i *ngIf="!expanded" class="material-icons">keyboard_double_arrow_right</i>
    </span>
  </div>

  <sa-nav-lmo
    [expanded]="expanded"
    (linkClicked)="expanded = false"
    class="flex-1"
    style="overflow: hidden;"
  ></sa-nav-lmo>
</div>
